import React, { Fragment, useMemo } from 'react';
import List from '@material-ui/core/List';
import SidebarMenuListItem from './SidebarMenuListItem';
import sidebarNavItems from '../Sidebar/sidebarNavItems';
import { extractItemsByUserPlan } from 'global/GlobalActions';
import { useSelector } from 'react-redux';
import { isActive } from 'components/watchlist/WatchlistHelpers';
import { useLocation } from 'react-router-dom';
import { SOCIAL_SENTIMENT_DOMAINS } from 'config/appConfig';

const SidebarMenu = () => {
  const location = useLocation();
  const allowedNavItems = useMemo(() => extractItemsByUserPlan(null, sidebarNavItems), []);
  const selectedItem = useSelector(state => state.Watchlist.selectedItem);

  const currentSocialSentimentDomain = useMemo(() => {
    if (location.pathname === '/socialSentiment') {
      return new URLSearchParams(location.search).get('domain') ?? SOCIAL_SENTIMENT_DOMAINS.GENERAL;
    }
  }, [location]);

  return (
    <List style={{ padding: 0 }}>
      {allowedNavItems.map((navItem, i) => {
        const disabled = !isActive(navItem.path, selectedItem);
        return (
          <Fragment key={i}>
            <SidebarMenuListItem navItem={navItem} disabled={disabled} />
            {navItem.children?.length ? (
              <>
                <List style={{ padding: '2px 0px 1px 12px' }}>
                  {navItem.children.map((navChlid, index) => (
                    <SidebarMenuListItem
                      key={index}
                      navItem={navChlid}
                      disabled={disabled}
                      isActiveLink={navChlid.domain === currentSocialSentimentDomain}
                    />
                  ))}
                </List>
              </>
            ) : null}
          </Fragment>
        );
      })}
    </List>
  );
};

export default SidebarMenu;
